import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { tableEditing, columnResizing, addColumnAfter, addColumnBefore, deleteColumn, addRowAfter, addRowBefore, deleteRow, mergeCells, splitCell, toggleHeaderRow, toggleHeaderColumn, toggleHeaderCell, deleteTable, goToNextCell } from 'prosemirror-tables';
import { TableView } from './TableView';
import { tableNodes } from './tableNodes';
import { keymap } from 'prosemirror-keymap';
import { findParentNodeOfType } from 'prosemirror-utils';
import { Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import { insertTable, toggleColorPalette, alignTable } from './actions';
import { getIconItem, getLabelItem, getDropdownItem, getColorPalette } from '../../utils/menu';
export const pluginKey = new PluginKey('table');
const tableMenu = [getLabelItem('table-column-before', __('Insert column before'), '', addColumnBefore), getLabelItem('table-column-after', __('Insert column after'), '', addColumnAfter), getLabelItem('table-delete-column', __('Delete column'), '', deleteColumn), getLabelItem('table-row-before', __('Insert row before'), '', addRowBefore), getLabelItem('table-row-after', __('Insert row after'), '', addRowAfter), getLabelItem('table-delete-row', __('Delete row'), '', deleteRow), getLabelItem('table-delete-table', __('Delete table'), '', deleteTable), getLabelItem('table-merge-cells', __('Merge cells'), '', mergeCells), getLabelItem('table-split-cell', __('Split cell'), '', splitCell), getLabelItem('table-header-column', __('Toggle header column'), '', toggleHeaderColumn), getLabelItem('table-header-row', __('Toggle header row'), '', toggleHeaderRow), getLabelItem('table-header-cells', __('Toggle header cells'), '', toggleHeaderCell), getColorPalette('cell-background-color', 'tap-icon-editor-text-highlighter', __('Cell background color'), toggleColorPalette, {
  markType: 'cell background'
}), getLabelItem('table-align-left', __('Align table left'), '', (state, dispatch) => alignTable(state, dispatch, 'align-left')), getLabelItem('table-align-center', __('Align table center'), '', (state, dispatch) => alignTable(state, dispatch, 'align-center')), getLabelItem('table-align-right', __('Align table right'), '', (state, dispatch) => alignTable(state, dispatch, 'align-right'))
// getLabelItem('table-toggle-border', __('Toggle border'), '', toggleBorder),
];

const isLastCellOfTable = state => {
  const {
    selection
  } = state;
  const {
    schema: {
      nodes: {
        table: tableNode,
        table_row: rowNode,
        table_cell: cellNode
      }
    }
  } = state;
  const table = findParentNodeOfType(tableNode)(selection);
  const row = findParentNodeOfType(rowNode)(selection);
  const cell = findParentNodeOfType(cellNode)(selection);
  return cell && row && table && row.node === table.node.lastChild && cell.node === row.node.lastChild;
};
const moveCursorToNextNode = (state, dispatch) => {
  if (isLastCellOfTable(state)) {
    const {
      selection
    } = state;
    const {
      schema: {
        nodes: {
          table: tableNode
        }
      }
    } = state;
    const table = findParentNodeOfType(tableNode)(selection);
    const nextPos = table.pos + table.node.nodeSize;
    const $nextNode = state.doc.resolve(nextPos);
    if (!$nextNode.nodeAfter) {
      const tr = state.tr.replaceWith(nextPos, nextPos, state.schema.nodes.paragraph.create({}));
      tr.setSelection(TextSelection.near(tr.doc.resolve(nextPos)));
      dispatch(tr);
      return true;
    }
    if (nextPos) {
      dispatch(state.tr.setSelection(TextSelection.near($nextNode)));
      return true;
    }
  }
  return false;
};
const handleArrowPress = (state, dispatch) => {
  moveCursorToNextNode(state, dispatch);
};
const handleTabPress = (state, dispatch, view) => {
  if (isLastCellOfTable(state)) {
    addRowAfter(state, dispatch);
    goToNextCell(1)(view.state, dispatch);
    return true;
  }
  return goToNextCell(1)(state, dispatch);
};
const getTablePosition = state => {
  const tableNode = state.schema.nodes.table;
  const node = state.doc.nodeAt(state.selection.$from.pos);
  return node && node.type === tableNode ? state.selection.$from.pos : null;
};
export default {
  name: 'table',
  configure: options => ({
    nodes: _objectSpread({}, tableNodes({
      tableGroup: 'block',
      cellContent: 'block+',
      cellAttributes: {
        background: {
          default: null,
          getFromDOM(dom) {
            return dom.style && dom.style.backgroundColor || null;
          },
          setDOMAttr(value, attrs, dom) {
            if (value && dom) {
              dom.style.backgroundColor = value;
            }
          }
        }
      },
      hasInlineStyles: options.hasInlineStyles
    })),
    plugins: [new Plugin({
      key: pluginKey,
      state: {
        init: (_, state) => ({
          pos: getTablePosition(state)
        }),
        apply: (tr, pluginState, _oldState, newState) => {
          if (tr.docChanged || tr.selectionSet) {
            const pos = getTablePosition(newState);
            const newPluginState = _objectSpread(_objectSpread({}, pluginState), {}, {
              pos
            });
            return newPluginState;
          }
          return pluginState;
        }
      }
    }), columnResizing({
      View: TableView
    }), tableEditing(), keymap({
      Tab: handleTabPress,
      'Shift-Tab': goToNextCell(-1),
      ArrowDown: handleArrowPress,
      ArrowRight: handleArrowPress
    })],
    floatingToolbars: [],
    menuItems: [getIconItem('insert-table', 'tap-icon-editor-table', 'Create Table', insertTable), getDropdownItem('table-actions', 'Table', tableMenu)]
  })
};